import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const FirstPage = () => {
  const [selectedLevel, setSelectedLevel] = useState('');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const chooseLevel = (level: string) => {
    setSelectedLevel(level);
    const speaker = searchParams.get('speaker') || 'Noah';
    navigate(`/?speaker=${speaker}&level=${level}`);
  };
  return (
    <div>
      <div id="levelPage" className="container">
        <h1>Choose your English level</h1>
        <p>اختر مستواك في اللغة الإنجليزية</p>
        <div className="buttons">
          {[
            { english: 'Beginner', arabic: 'مبتدئ' },
            { english: 'Elementary', arabic: 'المستوى الأساسي' },
            { english: 'Pre-Intermediate', arabic: 'المستوى قبل المتوسط' },
            { english: 'Intermediate', arabic: 'المستوى المتوسط' },
            { english: 'Upper Intermediate', arabic: 'فوق المتوسط' },
            { english: 'Advanced', arabic: 'متقدم' },
          ].map((level, index) => (
            <button
              key={index}
              className={`button level-button ${
                selectedLevel === level.english ? 'selected' : ''
              }`}
              onClick={() => chooseLevel(level.english)}
            >
              <span className="english">{level.english}</span>
              <span className="arabic">{level.arabic}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FirstPage;
